<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @exps="exps"
                    ref="SetBtn"></buttonlist>

        <el-tabs :tab-position="'top'" v-model="activeName" @tab-click="selectInfo" >
            <el-tab-pane :label="$t('getapi[8963]')" name="0">
                <div>
                    <el-button type="primary" size="mini" @click="monthCheck(0)">{{$t('getapi[1273]')}}</el-button>
                </div>
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="finrecinfotab"
                        :filter_language="['Issue_Part_Flow']"
                        :filter_thousandth="['Total_Amount','Rec_Money','NotRec_Money']"
                        :filter_date="['Payment_Date']"
                        :header="tableHeader"
                        :option="tableOption"
                        @lct="edit"
                        @handleSelectionChange="handleSelectionChange"
                        ref="singleTable"></wTable>
            </el-tab-pane>
            <el-tab-pane :label="$t('getapi[8964]')" name="1">
                <wTable
                        id="xpane-1"
                        :data="dataSet1"
                        queryData="finrecinfotab"
                        :filter_language="['Issue_Part_Flow']"
                        :filter_thousandth="['Total_Amount','Rec_Money','NotRec_Money']"
                        :filter_date="['Payment_Date']"
                        :loading="loading"
                        :header="tableHeader"
                        :option="tableOption1"
                        @lct="edit"
                        @handleSelectionChange="handleSelectionChange"
                        ref="singleTable1"></wTable>
            </el-tab-pane>
        </el-tabs>
        <el-row v-if="activeName == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="activeName == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <!-- </el-tabs> -->
        <serce :isVisible="isVisible" queryData="FinRecInfoView" ref="ser" @getser="serclick"></serce>
        <!-- </el-tabs> -->
        <serce :isVisible="isRVisible" queryData="RTFinRecInfoView" ref="ser" @getser="serclick"></serce>
        <!-- 改变表格顺序 -->
        <ctable :isVisible="false" :title="$t('getapi[1030]')" queryData="finrecinfotab" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="editVisiable" :title="$t('getapi[2903]')" width="40%"
                   :close-on-click-modal="false">
            <table>
                <tr>
                    <td style="width:60px">{{$t('getapi[2992]')}}</td>
                    <td style="width:150px;">
                        <el-input type="text" size="text" v-model="dataRow.Invoice_Code" :disabled="true"></el-input>
                    </td>
                    <td style="width:60px">{{$t('getapi[3861]')}}</td>
                    <td style="width:150px;">
                        <el-date-picker v-model="dataRow.Payment_Date" type="date" size="mini"
                                        style="width:100%"></el-date-picker>
                    </td>
                    <td style="width:60px">{{$t('getapi[8451]')}}</td>
                    <td style="width:80px;">
                        <el-input size="text" v-model="dataRow.Rec_Money" type="number" autocomplete="off" title=""
                                  @mousewheel.native.prevent></el-input>
                    </td>
                </tr>
            </table>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="editVisiable = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="confirmEditFinRecInfo" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[12338]')" :visible.sync="isEditVisible" width="30%">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[2992]')}}</td>
                        <td><el-input v-model="rowDetail.Invoice_No" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[8472]')}}</td>
                        <td><el-input v-model="rowDetail.Proforma_Invoice_No" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[2102]')}}</td>
                        <td><el-input v-model="rowDetail.Money" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input></td>
                        <td>{{$t('getapi[3861]')}}</td>
                        <td><el-date-picker v-model="rowDetail.Payment_Date" type="date" size="mini" style="width:100%"></el-date-picker></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8216]')}}</td>
                        <td><el-input v-model="rowDetail.Type" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[3099]')}}</td>
                        <td><el-input v-model="rowDetail.Create_Person" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[2950]')}}</td>
                        <td><el-input v-model="rowDetail.Create_Date" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[2610]')}}</td>
                        <td><el-input v-model="rowDetail.Customer_Code" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[143]')}}</td>
                        <td><el-input v-model="rowDetail.Remark"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isEditVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="confirmEdit">{{$t('getapi[937]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :title="$t('getapi[1273]')" :visible.sync="monthCheckVisible" width="30%">
            <table>
                <tr>
                    <td style="width:60px">{{ $t("getapi[1974]") }}</td>
                    <td style="width:150px;">
                        <el-select
                                filterable
                                v-model="year"
                                size="mini"
                                style="margin-righ:20px"
                        >
                            <el-option
                                    v-for="item in yearList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            ></el-option>
                        </el-select>
                    </td>
                    <td style="width:60px">{{ $t("getapi[1975]") }}</td>
                    <td style="width:150px;">
                        <el-select
                                filterable
                                v-model="month"
                                size="mini"
                                style="margin-righ:20px"
                        >
                            <el-option
                                    v-for="item in monthList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            ></el-option>
                        </el-select>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button size="small" @click="monthCheckVisible = false">{{$t('getapi[2054]')}}</el-button>
				<el-button size="small" type="primary" @click="confirmMonthCheck(0)">{{$t('getapi[2051]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import {Loading} from 'element-ui';

    export default {
        name: '3_finrecinfotab',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight1_1,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight1_1,
                }
            },
            tableOption1() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dialogVisible: false, //时间选择弹框
                dataSet: [], // 主表数据(按月)
                dataSet1:[],// 主表数据(汇总)
                isVisible: false, // 查询列表是否显示
                isRVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                queryData1: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_finrecinfotab'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('3_finrecinfotab'), // 当前页数据量
                total1:0,
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                tableHeader: [],
                dataDetail: {
                    Head: {},
                    Lists: []
                }, // 编辑页面数据详情
                PlanTypeArray: [], // 计划类型数组
                isEdit: true, // 是否新增操作
                selectData: [],
                dataRow: {},
                selectObj: {
                    part_code: '',
                    part_version: '',
                    exclusively_id: 0,
                    shelflife: ''
                },
                copyparam: {
                    startMonth: '',
                    copyMonth: '',
                },
                btn: {
                    //拷贝
                    copy: false,
                    //删除
                    delete: false,
                },
                monthList: [
                    {
                        value: 1,
                        label: 1,
                    },
                    {
                        value: 2,
                        label: 2,
                    },
                    {
                        value: 3,
                        label: 3,
                    },
                    {
                        value: 4,
                        label: 4,
                    },
                    {
                        value: 5,
                        label: 5,
                    },
                    {
                        value: 6,
                        label: 6,
                    },
                    {
                        value: 7,
                        label: 7,
                    },
                    {
                        value: 8,
                        label: 8,
                    },
                    {
                        value: 9,
                        label: 9,
                    },
                    {
                        value: 10,
                        label: 10,
                    },
                    {
                        value: 11,
                        label: 11,
                    },
                    {
                        value: 12,
                        label: 12,
                    },
                ],
                yearList: [],
                month: '',
                year: '',
                editVisiable: false,
                activeName:'0',
                isEditVisible: false,//行编辑弹窗
                rowDetail:{},//行明细
                monthCheckVisible: false,//月结
                scrollTop:0,
                scrollTop1:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(1)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
            that.colsort();
            let thisyear = new Date().getFullYear();
            for (let i = 0; i < 5; i++) {
                let obj = {
                    value: thisyear - i,
                    label: thisyear - i,
                };
                that.yearList.push(obj);
            }
            that.year = thisyear;
            let lastmonth = new Date().getMonth();
            let thismonth = new Date().getMonth() + 1;
            let myyear = new Date().getFullYear();
            if (lastmonth < 10) {
                lastmonth = '0' + lastmonth;
            }
            if (thismonth < 10) {
                thismonth = '0' + thismonth;
            }
            that.copyparam.startMonth = myyear + "-" + lastmonth;
            that.copyparam.copyMonth = myyear + "-" + thismonth;

        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('finrecinfotab', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[8219]"),this.$t("getapi[3846]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                let limits = 1;
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                //只读权
                if (that.total > 0 || that.total1 > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
            btnauthority() {
                let that = this;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_finrecinfotab', val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('3_finrecinfotab',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                if(that.activeName == 0){
                    that.isVisible = true;
                    that.$refs.ser.clearInput(that.isVisible, 'FinRecInfoView');
                } else if(that.activeName == 1){
                    that.isRVisible = true;
                    that.$refs.ser.clearInput(that.isRVisible, 'RTFinRecInfoView');
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //获取查询条件
            serclick(val) {
                let that = this
                if(that.activeName == 0){
                    this.queryData = val;
                } else {
                    this.queryData1 = val;
                }
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;

                if(that.activeName == 0) {
                    let datac = [];
                    for (let i = 0; i < that.queryData.length; i++) {
                        datac.push({
                            query_Condition: that.queryData[i].query_Condition,
                            query_field_type: that.queryData[i].Query_Field_Type,
                            query_field_name: that.queryData[i].Query_Field_Name,
                            query_sort: that.queryData[i].query_sort,
                            row_sign: that.queryData[i].row_sign
                        });
                    }
                    let data = {
                        PageIndex: that.pageIndex,
                        PageSize: that.pageSize,
                        Param: datac
                    };
                    that.$http.urlpost('/Finance/FrmSaleInvoice/CreateFinRecInfoTable', data, function (res) {
                        if (res.Success == 1) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                            that.loading = false;
                            that.DbTbNames = res.DbTbNames;
                        } else {
                            that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                        }
                        that.authority();
                    });
                } else {
                    let datac = [];
                    for (let i = 0; i < that.queryData1.length; i++) {
                        datac.push({
                            query_Condition: that.queryData1[i].query_Condition,
                            query_field_type: that.queryData1[i].Query_Field_Type,
                            query_field_name: that.queryData1[i].Query_Field_Name,
                            query_sort: that.queryData1[i].query_sort,
                            row_sign: that.queryData1[i].row_sign
                        });
                    }
                    let data = {
                        PageIndex: that.pageIndex1,
                        PageSize: that.pageSize1,
                        Param: datac
                    };
                    that.$http.urlpost('/Finance/FrmSaleInvoice/CreateFinRecInfoTableRealTime', data, function (res) {
                        if (res.Success == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                            that.loading = false;
                            that.DbTbNames = res.DbTbNames;
                        }
                        that.authority();
                    });
                }

            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                that.loading = true;
                if(that.activeName == 0){
                    let datac = [];
                    for (let i = 0; i < that.queryData.length; i++) {
                        datac.push({
                            query_Condition: that.queryData[i].query_Condition,
                            query_field_type: that.queryData[i].Query_Field_Type,
                            query_field_name: that.queryData[i].Query_Field_Name,
                            query_sort: that.queryData[i].query_sort,
                            row_sign: that.queryData[i].row_sign
                        });
                    }
                    let parm = {
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize,
                        SelectIndex: that.SelectIndexs,
                        Ids: '',
                        Param: datac,
                        LangType: that.$processdata.getLang(),
                        fromname:that.$t('getapi[8219]')+'('+that.$t('getapi[8963]')+')'
                    };
                    that.$http.urlpost('/Finance/FrmSaleInvoice/FinRecInfoTabExportToExecl', parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.loading = false;
                    });
                } else {
                    let datac = [];
                    for (let i = 0; i < that.queryData1.length; i++) {
                        datac.push({
                            query_Condition: that.queryData1[i].query_Condition,
                            query_field_type: that.queryData1[i].Query_Field_Type,
                            query_field_name: that.queryData1[i].Query_Field_Name,
                            query_sort: that.queryData1[i].query_sort,
                            row_sign: that.queryData1[i].row_sign
                        });
                    }
                    let parm = {
                        PageIndex: that.PageIndex,
                        PageSize: that.PageSize,
                        SelectIndex: that.SelectIndexs,
                        Ids: '',
                        Param: datac,
                        LangType: that.$processdata.getLang(),
                        fromname:that.$t('getapi[8219]')+'('+that.$t('getapi[8964]')+')'
                    };
                    that.$http.urlpost('/Finance/FrmSaleInvoice/FinRecInfoTabRealTimeExportToExecl', parm, function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.loading = false;
                    });
                }

                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "finrecinfotab",
                    fromname: that.$t('getapi[8219]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            monthCheck() {
                let that = this
                that.monthCheckVisible = true
            },
            confirmMonthCheck(val){
                let that = this
                if (that.month == '' || that.year == '') {
                    that.$message.warning(that.$t('getapi[8783]'))//'年月不能为空'
                    return
                }
                let parm = {
                    TYear: that.year,
                    Month: that.month,
                    Confirmflag: val
                }
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Finance/FrmSaleInvoice/FinRecInfoMonthCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.monthCheckVisible = false
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    } else if (res.Success == 2) {
                        that.$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                            confirmButtonText: that.$t('getapi[1146]'),
                            cancelButtonText: that.$t('getapi[2054]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.confirmMonthCheck(res.Success)
                            })
                            .catch(() => {
                                this.$message({
                                    type: 'info',
                                    message: that.$t('getapi[6096]')
                                });
                            });
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = val;
                console.log(that.selectData.length)
            },
            editFinRecInfo() {
                let that = this
                that.dataRow = that.selectData[0]
                that.editVisiable = true
            },
            confirmEditFinRecInfo() {
                let that = this
                let parm = that.dataRow
                that.$http.urlpost('/Finance/FrmSaleInvoice/EditFinRecInfoView', parm, function (res) {
                    if (res.Success == 1) {
                        that.getView()
                        that.editVisiable = false
                    }
                });
            },
            selectInfo(tab){
                let that = this;
                if (that.activeName ==0) {
                    that.SelectIndex = 0;
                    that.tabNo="0";
                } else if (that.activeName ==1) {
                    that.SelectIndex = 1;
                    that.tabNo="1";
                }
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
                that.colsort();
            },
            edit(row){
                let that  = this
                that.rowDetail = {
                    Exclusively_Id:'',
                    Invoice_No:row.row.Invoice_Code,
                    Proforma_Invoice_No:row.row.Proforma_Invoice_No==null?'':row.row.Proforma_Invoice_No,
                    Money:row.row.NotRec_Money,
                    Payment_Date:'',
                    Create_Person:'',
                    Create_Date:'',
                    Type:'',
                    Customer_Code:row.row.Customer_Code,
                    Remark:''
                }
                that.isEditVisible = true
            },
            confirmEdit(){
                let that = this
                let parm = that.rowDetail
                that.$http.urlpost('/Finance/FrmSaleInvoice/AddFinReceivablesTransaction', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.isEditVisible = false
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .bbl {
        margin: 0px auto 10px;
        white-space: pre;
        span {
            margin-left: 10px;
            min-width: 70px;
            text-align: left;
            line-height: 20px;
            display: inline-block;
            margin-right: 0px;
        }
    }
</style>
